import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { EComService } from 'src/app/ecom-services/ecom-common.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
//import { RatingConfig } from 'ngx-bootstrap/rating';
import { SessionStorageService, LocalStorageService } from 'ngx-webstorage';
import { EcomNetworkUtils } from 'src/app/ecom-base-entities/ecom-shared/ecom-networkutils.service';
import { HttpResponse } from '@angular/common/http';
import { EComWebStorage } from 'src/app/ecom-services/ecom-webstorage.services';
import { UserServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-userservicebase';
import { StoreServiceBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storeservicebase';
import { ItemBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-itembase';
import { StoreCartBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-storecartbase';
import { VariantBase } from 'src/app/ecom-base-entities/ecom-stores-base/ecom-item-base/ecom-variantbase';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EcomValidator } from 'src/app/ecom-services/ecom-validation';
import { Base64 } from 'js-base64';
import { EcomCookies } from '../../ecom-services/ecom-cookies';
import { EComGoogleAnalytics } from '@src/app/ecom-services/ecom-google-analytics';
// such override allows to keep some initial values
// export function getRatingConfig(): RatingConfig {
//   return Object.assign(new RatingConfig(), { ariaLabel: 'My Rating' });
// }

@Component({
  selector: 'app-ecom-orders',
  templateUrl: './ecom-orders.component.html',
  styleUrls: ['./ecom-orders.component.scss']
})
export class EcomOrdersComponent implements OnInit {
  // component class properties
  upcomingOrderList = [];
  pastOrderList = [];
  upcomingOrders = true;
  pastOrders = false;
  modalRef: BsModalRef;
  config = {
    animated: true,
    class: 'modal-dialog-centered'
  };
  max = 5;
  rate = 3;
  serviceType = 'DINE_IN';
  errorMessage: any;
  selectedOrder: any;
  userServiceBase: UserServiceBase;
  storeServiceBase: StoreServiceBase;
  invoiceMsg = '';
  invoiceRequest = true;
  invoiceEmail = '';
  emailForm: FormGroup;
  qrCodeScanned = false;
  defaultImage = './assets/images/storedefault.jpeg';
  // constructor to inject the class objects
  constructor(private eComGoogleAnalytics:EComGoogleAnalytics,public formBuilder: FormBuilder, public router: Router, public ecomservice: EComService,
    private modalService: BsModalService, private webstorage: EComWebStorage, private cookie: EcomCookies) {
    this.userServiceBase = new UserServiceBase();
    this.storeServiceBase = new StoreServiceBase({});
  }

  // component initialize and load the required data
  ngOnInit() {
    let gTag = {
      'event':'screen_view',
      'screen_name':'my orders'
    };
    this.eComGoogleAnalytics.customEvent(gTag);
    if (!this.webstorage.sessionSt_is_session_valid) {
      this.router.navigate(['home']);
    }
    // to disable reorder link
    if (this.webstorage.sessionSt_qr_code_scanned && this.webstorage.sessionSt_qr_code_scanned === true) {
      this.qrCodeScanned = this.webstorage.sessionSt_qr_code_scanned;
    }
    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
    this.upcomingOrders = true;
    this.pastOrders = false;
    if (this.cookie.cookie_authtoken === '') {
      this.router.navigate(['login']);
    } else {
      this.webstorage.sessionSt_frompage = 'orders';
      this.LoadPage()
    }
    this.emailForm = this.formBuilder.group({
      email: ['', Validators.compose([Validators.required, EcomValidator.emailValidator])]
    });

  }

  LoadPage() {
    if (!this.webstorage.localSt_client_id || !this.webstorage.localSt_olar_key) {
      const url = EcomNetworkUtils.POST_GENERATEKEY;
      this.ecomservice.httpPost(url, {}, '', true).subscribe((response) => {
        if (response.isSuccess) {
          if (!this.webstorage.localSt_client_id) {
            this.webstorage.localSt_client_id = response.listValue.oock_client_id;
          }
          // store public key
          this.webstorage.localSt_olar_key = response.listValue.oock_public_key;
          this.getUserOrders();
        }
      });
    } else {
      this.getUserOrders();
    }
  }

  // Method to get the user orders based on clientid
  getUserOrders() {
    //this.webstorage.sessionSt_weburl_order = false;
    //this.cookie.cookie_qrcodescan = false;
    this.upcomingOrderList = [];
    this.pastOrderList = [];
    const clientId = this.webstorage.localSt_client_id;
    const userId = this.webstorage.localSt_user_id;
    this.ecomservice.httpGet(EcomNetworkUtils.GET_USER_ORDERS + '?Id=' + clientId, '', true).subscribe((response) => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          let orderCount = 0;
          response.listValues.forEach(element => {
            let serviceType = '';
            if (element.oodcdr_type === 'COLLECTION') {
              serviceType = 'Collection';
            } else if (element.oodcdr_type === 'DELIVERY') {
              serviceType = 'Delivery';
            } else if (element.oodcdr_type === 'DINE_IN') {
              serviceType = 'DineIn';
            }
            if (element.oodcdr_status !== 'REJECT' && element.oodcdr_status !== 'COMPLETE') {
              const datetoday = new Date(new Date().setHours(0, 0, 0, 0));
              if (new Date(element.oodcdr_time) >= datetoday) {
                orderCount = orderCount + 1;
                const order = {
                  companyId: element.companyId,
                  orderGuid: element.oodcdr_guid,
                  companyGuid: element.oodcdr_company_guid,
                  companyName: element.CompanyName,
                  Currency: element.Currency,
                  Position: element.Position,
                  locationGuid: element.oodcdr_location_guid,
                  locationName: element.LocationName,
                  locationAddress: element.LocationAddress,
                  areaName: element.oodcdr_area_name,
                  areaGuid: element.oodcdr_ooa_guid,
                  tableGuid: element.oodcdr_oot_guid,
                  userName: element.oodcdr_name,
                  contact: element.oodcdr_mobile,
                  area: element.oodcdr_area_name,
                  date: element.order_date_time,
                  time: element.ServiceStartTime,
                  imagePath: element.BannerImage,
                  serviceType: serviceType,
                  orderServiceType: element.oodcdr_type,
                  saleOrder: {},
                  orderRating: undefined,
                  orderstatus: element.oodcdr_status,
                  ordercashback: Number(element.oodcdr_cashback_discount_total_amount),
                  ordertotalamount: Number(element.oodcdr_net_total_amount),
                  orderDiscount : Number(element.oodcdr_menu_discount_amount),
                  logopath: element.CompanyLogoPath,
                  CompanyBusinessNumber: element.CompanyBusinessNumber,
                  orderdatetime: element.oodcdr_time,
                  ListOrderTax: element.ListOrderTax,
                  referralDiscount: element.olarme_cashback_discount,
                  surcharges: element.sales_orders.sales_order_surcharges,
                  paymentstatus: element.PaymentStatus,
                  listcashback: element.list_olarme_cashback_discount,
                  paidby: element.order_payment_method,
                  tax_type: element.tax_type
                };

                order.ordertotalamount = order.ordertotalamount;

                if (element.mm_online_order_customer_ratings.length > 0) {
                  const orderRating = {
                    oocr_guid: element.mm_online_order_customer_ratings[0].oocr_guid,
                    oocr_ooc_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                    oocr_oodcdr_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                    oocr_location_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                    oocr_rating: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                    oocr_olar_cliend_id: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                    oocr_ctr_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                    companyId: element.mm_online_order_customer_ratings[0].companyId,
                    ratingdone: true
                  }
                  order.orderRating = orderRating;
                } else {
                  const orderRating = {
                    oocr_guid: undefined,
                    oocr_ooc_guid: this.webstorage.localSt_user_id,
                    oocr_oodcdr_guid: order.orderGuid,
                    oocr_location_guid: order.locationGuid,
                    oocr_rating: 0,
                    oocr_olar_cliend_id: this.webstorage.localSt_client_id,
                    oocr_ctr_guid: undefined,
                    companyId: order.companyId,
                    ratingdone: false
                  }
                  order.orderRating = orderRating;
                }

                const saleOrder = {
                  sales_order_guid: element.sales_orders.sales_order_guid,
                  sales_order_id: element.sales_orders.sales_order_id,
                  sales_order_number: element.sales_orders.sales_order_number,
                  orderSubTotal: Number(element.sales_orders.sales_order_gross_total),
                  orderTaxTotal: Number(element.sales_orders.sales_order_tax_total),
                  orderTotal: Number(element.sales_orders.sales_order_net_total_amount),
                  surcharge: Number(element.sales_orders.sales_order_surcharge_total),
                  delivery_charge: Number(element.sales_orders.sales_order_delivery_charge_total),
                  delivery_tax: Number(element.sales_orders.sales_order_delivery_tax_amount),
                  sales_order_delivery_tax_guid:element.sales_orders.sales_order_delivery_tax_guid,
                  orderItems: []
                }
                order.saleOrder = saleOrder;
                let cashbackTotal = 0;
                if (order.listcashback) {
                  order.listcashback.forEach(element => {
                    cashbackTotal = cashbackTotal + element.ooocd_amount;
                  });
                }
                //before adding delivery tax check if same kind of tax exist for items if not then add else no need to add
                let taxExist = element.ListOrderTax.find(obj=>{
                  return obj.TaxGuid === saleOrder.sales_order_delivery_tax_guid;
                });
                if (order.tax_type === "TAX_IN") {
                  order.ordertotalamount = (saleOrder.orderSubTotal + saleOrder.delivery_charge + saleOrder.delivery_tax + saleOrder.surcharge) - cashbackTotal;
                } else {
                  if(taxExist === undefined){
                    order.ordertotalamount = (saleOrder.orderSubTotal + saleOrder.orderTaxTotal + saleOrder.delivery_charge + saleOrder.delivery_tax + saleOrder.surcharge) - cashbackTotal;
                  } else {
                    order.ordertotalamount = (saleOrder.orderSubTotal + saleOrder.orderTaxTotal + saleOrder.delivery_charge + saleOrder.surcharge) - cashbackTotal;
                  }
                }

                if (order.ordertotalamount < 0) {
                  order.ordertotalamount = 0;
                }
                element.sales_orders.mm_sales_order_items.forEach((saleitem, index) => {
                  const item = {
                    count: index + 1,
                    itemName: saleitem.soi_item_name,
                    itemhasVariant: saleitem.soi_item_has_variant,
                    variant: [],
                    modifierset: [],
                    totalPrice: 0
                  }
                  if (saleitem.soi_item_has_variant) {
                    saleitem.mm_sales_order_items_standard_composite_variant_service_details.forEach(salevariant => {
                      const variant = {
                        variantName: salevariant.soiscvsd_name,
                        variantPrice: salevariant.soiscvsd_price,
                        variantTax: salevariant.soiscvsd_tax_amount,
                        variantQty: salevariant.soiscvsd_quantity,
                        soiscvsd_isvsd_guid: salevariant.soiscvsd_isvsd_guid
                      };
                      item.totalPrice = item.totalPrice + (variant.variantQty * variant.variantPrice);
                      item.variant.push(variant);
                    });
                  }
                  if (saleitem.hasModifer) {
                    saleitem.mm_sales_order_modifier_mapping.forEach(modSet => {
                      const modifierSet = {
                        modGuid: modSet.somm_guid,
                        somm_soi_guid: modSet.somm_soi_guid,
                        somm_imm_guid: modSet.somm_imm_guid,
                        somm_modifier_name: modSet.somm_modifier_name,
                        modifierOption: []
                      };
                      modSet.mm_sales_order_modifier_mapping_options.forEach(modOption => {
                        const option = {
                          sommo_guid: modOption.sommo_guid,
                          sommo_somm_guid: modOption.sommo_somm_guid,
                          sommo_immo_guid: modOption.sommo_immo_guid,
                          sommo_option_name: modOption.sommo_option_name,
                          sommo_tax_amount: modOption.sommo_tax_amount,
                          sommo_price: modOption.sommo_price,
                          sommo_quantity: modOption.sommo_quantity
                        }
                        item.totalPrice = item.totalPrice + (option.sommo_quantity * option.sommo_price);
                        modifierSet.modifierOption.push(option);
                      });
                      item.modifierset.push(modifierSet);
                    });
                  }
                  saleOrder.orderItems.push(item);
                });

                this.upcomingOrderList.push(order);
                this.upcomingOrderList.sort((a, b) => a.orderdatetime > b.orderdatetime ? -1 : a.orderdatetime < b.orderdatetime ? 1 : 0);
              }
            } else {
              const order = {
                companyId: element.companyId,
                orderGuid: element.oodcdr_guid,
                companyGuid: element.oodcdr_company_guid,
                companyName: element.CompanyName,
                Currency: element.Currency,
                Position: element.Position,
                locationGuid: element.oodcdr_location_guid,
                locationName: element.LocationName,
                locationAddress: element.LocationName,
                areaName: element.oodcdr_area_name,
                areaGuid: element.oodcdr_ooa_guid,
                tableGuid: element.oodcdr_oot_guid,
                userName: element.oodcdr_name,
                contact: element.oodcdr_mobile,
                area: element.oodcdr_area_name,
                date: element.order_date_time,
                time: element.ServiceStartTime,
                imagePath: element.BannerImage,
                serviceType: serviceType,
                orderServiceType: element.oodcdr_type,
                saleOrder: {},
                orderRating: undefined,
                orderstatus: element.oodcdr_status,
                ordercashback: Number(element.oodcdr_cashback_discount_total_amount),
                ordertotalamount: Number(element.oodcdr_net_total_amount),
                orderDiscount : Number(element.oodcdr_menu_discount_amount),
                logopath: element.CompanyLogoPath,
                CompanyBusinessNumber: element.CompanyBusinessNumber,
                orderdatetime: element.oodcdr_time,
                ListOrderTax: element.ListOrderTax,
                referralDiscount: element.olarme_cashback_discount,
                surcharges: element.sales_orders.sales_order_surcharges,
                paymentstatus: element.PaymentStatus,
                listcashback: element.list_olarme_cashback_discount,
                paidby: element.order_payment_method,
                tax_type: element.tax_type
              };

              if (element.mm_online_order_customer_ratings.length > 0) {
                const orderRating = {
                  oocr_guid: element.mm_online_order_customer_ratings[0].oocr_guid,
                  oocr_ooc_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                  oocr_oodcdr_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                  oocr_location_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                  oocr_rating: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                  oocr_olar_cliend_id: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                  oocr_ctr_guid: element.mm_online_order_customer_ratings[0].oocr_ooc_guid,
                  companyId: element.mm_online_order_customer_ratings[0].companyId,
                  ratingdone: true
                }
                order.orderRating = orderRating;
              } else {
                const orderRating = {
                  oocr_guid: undefined,
                  oocr_ooc_guid: this.webstorage.localSt_user_id,
                  oocr_oodcdr_guid: order.orderGuid,
                  oocr_location_guid: order.locationGuid,
                  oocr_rating: 0,
                  oocr_olar_cliend_id: this.webstorage.localSt_client_id,
                  oocr_ctr_guid: undefined,
                  companyId: order.companyId,
                  ratingdone: false
                }
                order.orderRating = orderRating;
              }

              const saleOrder = {
                sales_order_guid: element.sales_orders.sales_order_guid,
                sales_order_id: element.sales_orders.sales_order_id,
                sales_order_number: element.sales_orders.sales_order_number,
                orderSubTotal: Number(element.sales_orders.sales_order_gross_total),
                orderTaxTotal: Number(element.sales_orders.sales_order_tax_total),
                orderTotal: Number(element.sales_orders.sales_order_net_total_amount),
                surcharge: Number(element.sales_orders.sales_order_surcharge_total),
                delivery_charge: Number(element.sales_orders.sales_order_delivery_charge_total),
                delivery_tax: Number(element.sales_orders.sales_order_delivery_tax_amount),
                sales_order_delivery_tax_guid:element.sales_orders.sales_order_delivery_tax_guid,
                orderItems: []
              }
              order.saleOrder = saleOrder;
              let cashbackTotal = 0;
              if (order.listcashback) {
                order.listcashback.forEach(element => {
                  cashbackTotal = cashbackTotal + element.ooocd_amount;
                });
              }
              //before adding delivery tax check if same kind of tax exist for items if not then add else no need to add
              let taxExist = element.ListOrderTax.find(obj=>{
                return obj.TaxGuid === saleOrder.sales_order_delivery_tax_guid;
              });
              if (order.tax_type === "TAX_IN") {
                order.ordertotalamount = (saleOrder.orderSubTotal + saleOrder.delivery_charge + saleOrder.delivery_tax + saleOrder.surcharge) - cashbackTotal;
              } else {
                if(taxExist === undefined){
                  order.ordertotalamount = (saleOrder.orderSubTotal + saleOrder.orderTaxTotal + saleOrder.delivery_charge + saleOrder.delivery_tax +  saleOrder.surcharge) - cashbackTotal;
                } else{
                  order.ordertotalamount = (saleOrder.orderSubTotal + saleOrder.orderTaxTotal + saleOrder.delivery_charge + saleOrder.surcharge) - cashbackTotal;
                }
              }
              if (order.ordertotalamount < 0) {
                order.ordertotalamount = 0;
              }

              element.sales_orders.mm_sales_order_items.forEach((saleitem, index) => {
                const item = {
                  count: index + 1,
                  itemName: saleitem.soi_item_name,
                  itemhasVariant: saleitem.soi_item_has_variant,
                  variant: [],
                  modifierset: [],
                  totalPrice: 0
                }
                if (saleitem.soi_item_has_variant) {
                  saleitem.mm_sales_order_items_standard_composite_variant_service_details.forEach(salevariant => {
                    const variant = {
                      variantName: salevariant.soiscvsd_name,
                      variantPrice: salevariant.soiscvsd_price,
                      variantTax: salevariant.soiscvsd_tax_amount,
                      variantQty: salevariant.soiscvsd_quantity,
                      soiscvsd_isvsd_guid: salevariant.soiscvsd_isvsd_guid
                    };
                    item.totalPrice = item.totalPrice + (variant.variantQty * variant.variantPrice);
                    item.variant.push(variant);
                  });
                }
                if (saleitem.hasModifer) {
                  saleitem.mm_sales_order_modifier_mapping.forEach(modSet => {
                    const modifierSet = {
                      modGuid: modSet.somm_guid,
                      somm_soi_guid: modSet.somm_soi_guid,
                      somm_imm_guid: modSet.somm_imm_guid,
                      somm_modifier_name: modSet.somm_modifier_name,
                      modifierOption: []
                    };
                    modSet.mm_sales_order_modifier_mapping_options.forEach(modOption => {
                      const option = {
                        sommo_guid: modOption.sommo_guid,
                        sommo_somm_guid: modOption.sommo_somm_guid,
                        sommo_immo_guid: modOption.sommo_immo_guid,
                        sommo_option_name: modOption.sommo_option_name,
                        sommo_tax_amount: modOption.sommo_tax_amount,
                        sommo_price: modOption.sommo_price,
                        sommo_quantity: modOption.sommo_quantity
                      }
                      item.totalPrice = item.totalPrice + (option.sommo_quantity * option.sommo_price);
                      modifierSet.modifierOption.push(option);
                    });
                    item.modifierset.push(modifierSet);
                  });
                }
                saleOrder.orderItems.push(item);
              });
              this.pastOrderList.push(order);
              this.pastOrderList.sort((a, b) => a.orderdatetime > b.orderdatetime ? -1 : a.orderdatetime < b.orderdatetime ? 1 : 0);
            }
          });
          this.webstorage.sessionSt_order_count = orderCount;
        } else {
          this.ecomservice.commonLoading.show = false;
          this.router.navigate(['login']);
        }
      }
    });
  }

  // Method to handle the ordertype tab click event
  onOrderTypeClick(type) {
    if (type === 'PAST_ORDERS') {
      this.upcomingOrders = false;
      this.pastOrders = true;
    } else if (type === 'UPCOMING_ORDERS') {
      this.upcomingOrders = true;
      this.pastOrders = false;
    }
  }

  // Method to handle the view receipt click event
  onViewRecieptClick(order) {
    this.selectedOrder = order;
  }

  // Method to handle the status click event 
  onViewStatusClick(order) {
    if (order.orderServiceType === 'DINE_IN') {
      this.webstorage.sessionSt_status_companyid = order.companyId;
      this.webstorage.sessionSt_status_serviceid = order.orderGuid;
      this.router.navigate(['status-dinein']);
    } else if (order.orderServiceType === 'COLLECTION') {
      this.webstorage.sessionSt_status_companyid = order.companyId;
      this.webstorage.sessionSt_status_serviceid = order.orderGuid;
      this.router.navigate(['status-collection']);
    } else if (order.orderServiceType === 'DELIVERY') {
      this.webstorage.sessionSt_status_companyid = order.companyId;
      this.webstorage.sessionSt_status_serviceid = order.orderGuid;
      this.router.navigate(['status-delivery']);
    } else if (order.orderServiceType === 'RESERVATION') {
      this.webstorage.sessionSt_status_companyid = order.companyId;
      this.webstorage.sessionSt_status_serviceid = order.orderGuid;
      this.router.navigate(['confirm-reservation']);
    }
  }

  // Method to handle the action click event
  onActionClick(type, template, order) {
    this.selectedOrder = order;
    switch (type) {
      case 'VIEW_RECEIPT':
        this.modalRef = this.modalService.show(template, this.config);
        this.onViewRecieptClick(order);
        break;
      case 'RATE_TIPS':
        this.modalRef = this.modalService.show(template, this.config);
        break;
      case 'RE_ORDER':
        this.onReorderClick(order);
        break;
    }
  }

  // Method to get the dateformt
  getDateFormat(today: Date) {
    let day = today.getDate() + '';
    let month = (today.getMonth() + 1) + '';
    let year = today.getFullYear() + '';
    let hour = today.getHours() + '';
    let minutes = today.getMinutes() + '';
    let seconds = today.getSeconds() + '';

    day = this.checkZero(day);
    month = this.checkZero(month);
    year = this.checkZero(year);
    hour = this.checkZero(hour);
    minutes = this.checkZero(minutes);
    seconds = this.checkZero(seconds);
    return year + '-' + month + '-' + day + ' ' + hour + ':' + minutes + ':' + seconds;
  }

  // Method to get the time format
  getTimeFormat(minutestoadd = 1): any {
    // add extra one minute for buffer value
    let today = new Date();
    let hour = today.getHours();
    let minutes: any = today.getMinutes() + minutestoadd;
    if (minutes >= 60) {
      hour = hour + 1;
      minutes = minutes - 60;
      if (minutes < 10) {
        minutes = '0' + minutes;
      }
    } else if (minutes < 10) {
      minutes = '0' + minutes;
    }
    let seconds: any = today.getSeconds();
    if (seconds < 10) {
      seconds = '0' + seconds;
    }
    //const time = hour + ':' + minutes + ':' + seconds;
    const time = hour + ':' + minutes;
    return time;
  }

  // method to check and append the zero
  checkZero(data) {
    if (data.length === 1) {
      data = '0' + data;
    }
    return data;
  }

  // Method to handle the reorder click event
  onReorderClick(order) {
    // add location details
    /*
    const today = new Date();
    let datetime = this.getDateFormat(today) + this.getTimeFormat(30);

    if (this.webstorage.localSt_user_service_request === null) {
      this.userServiceBase = new UserServiceBase();
    } else {
      this.userServiceBase = this.webstorage.localSt_user_service_request;
    }
    this.userServiceBase.userCurrentLocationIn = order.locationGuid;
    this.storeServiceBase = new StoreServiceBase();
    this.storeServiceBase.serviceLocationAddress = order.locationAddress;
    this.storeServiceBase.serviceLocationName = order.locationName;
    this.storeServiceBase.serviceType = order.orderServiceType;
    this.serviceType = order.orderServiceType;
    this.storeServiceBase.serviceDatetime = datetime;
    this.storeServiceBase.serviceStatus = 'OPEN';
    this.storeServiceBase.serviceLocationGuid = order.locationGuid;
    this.storeServiceBase.serviceCompanyGuid = order.companyGuid;
    this.storeServiceBase.serviceLocationAreaId = order.areaGuid;
    this.storeServiceBase.serviceLocationAreaName = order.areaName;
    this.storeServiceBase.serviceLocationTableId = order.tableGuid;
    this.storeServiceBase.serviceLocationTableName = '';
    this.storeServiceBase.serviceCompanyId = order.companyId;
    if (this.userServiceBase.selectedStoreServiceList === undefined || this.userServiceBase.selectedStoreServiceList.length === 0) {
      this.userServiceBase.selectedStoreServiceList = [];
      this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
      this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
    } else {
      this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
      this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);

      let storeIndex = -1;
      const storeselected = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        storeIndex = index;
        return this.ecomservice.stringCompare(obj.serviceLocationGuid, this.userServiceBase.userCurrentLocationIn);
      });
      if (storeselected === undefined) {
        this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
        this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
        this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
      } else {
        if (storeselected.serviceType === this.serviceType) {
          this.userServiceBase.selectedStoreServiceList[storeIndex].serviceDatetime = datetime;
          this.userServiceBase.selectedStoreServiceList[storeIndex].serviceLocationGuid = order.locationGuid;
          this.userServiceBase.selectedStoreServiceList[storeIndex].serviceLocationAreaId = order.areaGuid;
          this.userServiceBase.selectedStoreServiceList[storeIndex].serviceLocationAreaName = order.areaName;
          this.userServiceBase.selectedStoreServiceList[storeIndex].serviceLocationTableId = order.tableGuid;
        } else {
          this.storeServiceBase.serviceActiveId = this.userServiceBase.selectedStoreServiceList.length + 1;
          this.userServiceBase.selectedStoreServiceList.push(this.storeServiceBase);
          this.webstorage.sessionSt_service_active_id = this.storeServiceBase.serviceActiveId;
        }
      }
    }
    this.webstorage.localSt_user_service_request = this.userServiceBase;
    */
    // add items to cart
    // order.saleOrder.orderItems.forEach(saleitem => {
    //   const cartItem = new ItemBase();
    //   cartItem.variantList = [];
    //   const variant = new VariantBase();
    //   // check of per day limit before doing reorder
    //   variant.variantGuid = saleitem.variant[0].soiscvsd_isvsd_guid;
    //   variant.selected = true;
    //   cartItem.variantList.push(variant);
    //   this.updateCart(cartItem, order);
    // });
    //redirect to store page
    this.webstorage.sessionSt_company_clicked = order.companyName.trim().replace(/\s+/g, '-').toLowerCase();
    let companyId = order.companyId;
    let encodeCompanyId = Base64.encode(companyId);
    this.webstorage.sessionSt_frompage = 'orders';
    //this.router.navigate(['store'], { queryParams: { Id: encodeCompanyId, locationGuid: order.locationGuid } });
    this.router.navigate(['items', this.webstorage.sessionSt_company_clicked], { queryParams: { Id: encodeCompanyId, locationGuid: order.locationGuid } });
  }

  // Method to add the selected order item to cart
  updateCart(item: ItemBase, order) {
    if (item) {
      // filter the location based cart
      this.serviceType = this.webstorage.sessionSt_service_type;
      const serviceActiveId = this.webstorage.sessionSt_service_active_id;
      let userStoreIndex = -1;
      let selectedStore = this.userServiceBase.selectedStoreServiceList.find((obj, index) => {
        userStoreIndex = index;
        return this.ecomservice.stringCompare(obj.serviceLocationGuid, order.locationGuid) && !obj.serviceCompleted && obj.serviceType === this.serviceType;
      });
      if (selectedStore !== undefined) {
        if (!this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart) {
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart = new StoreCartBase();
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderServiceCharge = 0;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderSubTotal = 0;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderTax = 0;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderTotal = 0;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderDiscountTotal = 0;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.cartEmpty = false;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems = [];
          // selected from item details
          // const selectedItemVariant = item.variantList.find((obj) => {
          //   return obj.selected === true;
          // });
          item.variantList = [];
          item.variantList.push(item.variantList[0]);
          // first item
          item.itemId = 1;
          this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.push(item);
        } else {
          // base item index
          let basecartItemIndex = -1;
          let baseCartItem = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.find((obj, index) => {
            basecartItemIndex = index;
            return this.ecomservice.stringCompare(obj.itemGuid, item.itemGuid);
          });
          // get the items in the cart matching with item guid
          const cartItems = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.filter(x => x.itemGuid === item.itemGuid);
          // loop and check if item is same and different
          if (cartItems && cartItems.length > 0) {
            let isDifferentItem = false;
            let sameItemIndex = -1;
            let optiondifferent = false;
            cartItems.forEach((cartItem, cartItemIndex) => {
              // selected from item details
              const selectedItemVariant = item.variantList[0];
              if (selectedItemVariant !== undefined) {
                sameItemIndex = cartItemIndex;
                // check if the selected item variant and cart item variant are same
                const cartItemvariant = cartItem.variantList[0];
                // if variant is different then add a new item else update it's count
                if (cartItemvariant && this.ecomservice.stringCompare(selectedItemVariant.variantGuid, cartItemvariant.variantGuid)) {
                  // check for modifier set is varied if so then add it as new item else update the count
                  // check for modifier set quantity of cartitem already selected                  
                  if (cartItem.modifierSetList.length !== 0) {
                    cartItem.modifierSetList.forEach(cartmodifierset => {
                      optiondifferent = false;
                      item.modifierSetList.forEach(selectedmodifierset => {
                        // check if modifier set option is different
                        selectedmodifierset.modifierOptions.forEach(selecteditemoption => {
                          cartmodifierset.modifierOptions.forEach(cartitemoption => {
                            if (selecteditemoption.optionSelected !== cartitemoption.optionSelected) {
                              optiondifferent = true;
                              return;
                            }
                          });
                        });
                      });
                    });
                  } else {
                    isDifferentItem = false;
                    return;
                  }
                  if (optiondifferent) {
                    isDifferentItem = true;
                    return;
                  }
                } else {
                  optiondifferent = true;
                  isDifferentItem = true;
                  return;
                }
              }
              if (isDifferentItem) {
                return;
              }
            });

            if (isDifferentItem && optiondifferent) {
              // selected from item details
              const selectedItemVariant = item.variantList.find((obj) => {
                return obj.selected === true;
              });
              item.variantList = [];
              item.variantList.push(selectedItemVariant);
              let itemCount = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.length;
              item.itemId = itemCount + 1;
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.push(item);
            } else {
              let itemCount = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.length;
              item.itemId = itemCount;
              const itemQty = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems[sameItemIndex + basecartItemIndex].quantity;
              const variantQty = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems[sameItemIndex + basecartItemIndex].variantList[0].variantQty;
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems[sameItemIndex + basecartItemIndex].variantList[0].variantQty = variantQty + 1;
              this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems[sameItemIndex + basecartItemIndex].quantity = itemQty + 1;
            }
          } else {
            // selected from item details
            const selectedItemVariant = item.variantList.find((obj) => {
              return obj.selected === true;
            });
            item.variantList = [];
            item.variantList.push(selectedItemVariant);
            let itemCount = this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.length;
            item.itemId = itemCount + 1;
            this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderItems.push(item);
          }
        }

        this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderSubTotal = Number(this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderSubTotal) + Number(item.totalPrice);
        this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderTax = Number(this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderTax) + Number(item.totalTax);
        this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderTotal = Number(this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderSubTotal) + Number(this.userServiceBase.selectedStoreServiceList[userStoreIndex].storeCart.orderTax);

        this.webstorage.sessionSt_cart_item = null;
      }
      //this.userServiceBase.selectedStoreServiceList[userStoreIndex] = selectedStore;
      this.webstorage.localSt_user_service_request = this.userServiceBase;
    }
  }

  // Method to handle the rating click event
  onRatingHide() {
    // save the rating points here
    this.modalRef.hide();
    //$('.modal').css({"display": "none"});
    const rateInput = {
      oocr_ooc_guid: this.webstorage.localSt_user_id,
      oocr_oodcdr_guid: this.selectedOrder.orderGuid,
      oocr_location_guid: this.selectedOrder.locationGuid,
      oocr_rating: this.rate,
      oocr_olar_cliend_id: this.webstorage.localSt_client_id,
      oocr_ctr_guid: '',
      companyId: this.selectedOrder.companyId
    }
    const url = EcomNetworkUtils.POST_UPDATE_LOCATION_RATING;
    this.ecomservice.httpPost(url, rateInput, '', false).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          // update the rating status
          let orderIndex = -1;
          var order = this.pastOrderList.find((obj, index) => {
            orderIndex = index;
            return this.ecomservice.stringCompare(obj.orderGuid, this.selectedOrder.orderGuid);
          });
          if (order !== undefined) {
            this.pastOrderList[orderIndex].orderRating.ratingdone = true;
          }
        }
      }
    });
  }

  onSendEmailClick(order) {
    if (this.emailForm.invalid) {
      Object.keys(this.emailForm.controls).forEach(key => {
        this.emailForm.get(key).markAsDirty();
      });
      return;
    } else {
      const input = {
        CompanyId: order.companyId,
        OrderGuid: order.orderGuid,
        Type: order.orderServiceType,
        Email: this.emailForm.value.email
      };
      this.ecomservice.httpPost(EcomNetworkUtils.POST_SEND_INVOICE, input, '', true).subscribe(response => {
        if (response['status'] === 403) {
          this.router.navigate(['unauthorized']);
        } else {
          if (response.isSuccess) {
            this.invoiceMsg = 'Email sent successfully, check your inbox';
            this.invoiceRequest = true;
            //this.closeInvoicAuto();
          } else {
            this.invoiceRequest = false;
            this.invoiceMsg = 'Error in sending email try after sometime';
          }
        }
      });
    }
  }

  onDownloadPdfClick(order) {
    const input = {
      CompanyId: order.companyId,
      OrderGuid: order.orderGuid,
      Type: order.orderServiceType,
      Email: ''
    };
    this.ecomservice.httpPost(EcomNetworkUtils.POST_PRINT_PREVIEW, input, '', true).subscribe(response => {
      if (response['status'] === 403) {
        this.router.navigate(['unauthorized']);
      } else {
        if (response.isSuccess) {
          const linkSource = 'data:application/pdf;base64,' + response['listValue'].replace(/\s/g, '');
          const downloadLink = document.createElement("a");
          const fileName = "Invoice.pdf";
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          this.invoiceMsg = 'Invoice Generated Successfully';
          this.invoiceRequest = true;
          //this.closeInvoicAuto();
        } else {
          this.invoiceRequest = false;
          this.invoiceMsg = 'Error in generating invoice try after sometime';
        }
      }
    });
  }
}
